export const formTsAgreementTransactionFields = {
  PRICE: 'price',
  CHECKBOX: 'checkbox',
};
